import styled, { css } from 'styled-components';
import { themeHelpers } from '@gotamedia/fluffy/theme';
const Wrapper = styled.footer.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-ytf2wv-0"
})(["width:100%;display:flex;margin:auto 0 0 0;background-color:", ";*{color:#ffffff;}"], ({
  theme
}) => theme.colors.grey[0]);
const InnerWrapper = styled.div.withConfig({
  displayName: "style__InnerWrapper",
  componentId: "sc-ytf2wv-1"
})(["max-width:1320px;width:90%;margin:15px auto;display:flex;flex-direction:column;", ""], themeHelpers.isSmallDevice(css(["flex-direction:column;"])));
const Flex = styled.div.withConfig({
  displayName: "style__Flex",
  componentId: "sc-ytf2wv-2"
})(["display:flex;padding:20px;flex-direction:column;&:first-child{flex:2;}&:last-child{flex:1;}p,h2{white-space:pre-line;margin-bottom:5px;}"]);
export { Wrapper, InnerWrapper, Flex };